import { styled } from '@mui/material/styles';
import DialogActions from '@mui/material/DialogActions';

export const StyledDialogActions = styled(DialogActions, {
  shouldForwardProp: (prop) => prop !== 'fullWidth'
})(({ fullWidth }) => ({
  ...(fullWidth && {
    width: '100%'
  })
}));



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpDialogActions/styles.js